import { render, staticRenderFns } from "./EventsTimeline.vue?vue&type=template&id=5ca48375"
import script from "./EventsTimeline.vue?vue&type=script&lang=js"
export * from "./EventsTimeline.vue?vue&type=script&lang=js"
import style0 from "./EventsTimeline.vue?vue&type=style&index=0&id=5ca48375&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports